import { AppState } from 'src/app/app.state';

export const selectSessionId = (state: AppState): string => state.session.id;
